<template>
  <v-btn
    :class="{'sm-notification-button': isHeader}"
    :icon="isHeader"
    variant="text"
    :data-cy="isHeader ? 'notifications-sidenav' : 'notifications-bottomnav'"
    @click="displayDrawer"
  >
    <v-badge
      color="red"
      :offset="[isHeader ? 12 : 10, isHeader ? 0 : 2]"
      :content="notificationsCountAsString"
      :model-value="unseenNotificationsCount > 0"
    >
      <v-icon
        class="text-secondary"
      >
        ico-sm-notifications-line
      </v-icon>
    </v-badge>
  </v-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useNotificationStore } from '@src/pinia/notifications'
import { storeToRefs } from 'pinia'
import useTracking from '@src/composables/tracking/tracking'

export default defineComponent({
  name: 'SMNotificationsButton',
  props: {
    isHeader: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const { trackMixpanelEvent } = useTracking()
    const notificationStore = useNotificationStore()
    const { unseenNotificationsCount, notificationsCountAsString, drawerVisible } = storeToRefs(notificationStore)
    const { showDrawer } = notificationStore

    function displayDrawer(): void {
      trackNotificationClick()
      showDrawer()
    }
    function trackNotificationClick() {
      trackMixpanelEvent(
        'clickNotificationIcon',
        {
          component: 'SMNotificationsButton',
          icon_status: unseenNotificationsCount.value > 0 ? 'unseen' : 'seen'
        }
      )
    }

    return {
      unseenNotificationsCount,
      notificationsCountAsString,
      drawerVisible,
      displayDrawer
    }
  }
})
</script>

<style lang="scss" scoped>
  @use "~@styles/constants" as consts;
  :deep(.sm-notification-button) {
    cursor: pointer;
    width: 50px;
    border-radius: 50% !important;
    background-color: transparent !important;

    &:hover{
      background-color: #F5F5F5;
    }
  }

  :deep(.v-badge__badge) {
    padding: 2px 3px;
    height: 16px;
    min-width: 16px;
    font-size: 11px;
    font-weight: bold;
  }
</style>
